import { resolvePublicFileUrl } from '../../utils/imageUrls';
import type { HeroImage } from './types';

export type PublicGalleryImage = {
  id?: number;
  image_url: string;
  image_type?: string;
  title?: string;
  alt_text?: string;
  focal_x?: number | null;
  focal_y?: number | null;
};

export function galleryFingerprint(
  images: PublicGalleryImage[] | undefined | null
): string {
  if (!images?.length) return '';
  return images
    .map(
      (img) =>
        `${img.id ?? ''}|${img.image_url}|${img.title ?? ''}|${img.alt_text ?? ''}|${img.focal_x ?? ''}|${img.focal_y ?? ''}`
    )
    .join('\n');
}

export function mapPublicImagesToHero(
  images: PublicGalleryImage[] | undefined | null,
  label: string,
  getFileUrl: (path: string) => string | null
): HeroImage[] {
  if (!images?.length) return [];
  return images.map((img, index) => ({
    id: String(img.id ?? index),
    src:
      resolvePublicFileUrl(img.image_url) ||
      getFileUrl(img.image_url) ||
      img.image_url,
    alt: img.alt_text || `${label} photo ${index + 1}`,
    title: img.title || `Photo ${index + 1}`,
    focalX: img.focal_x ?? null,
    focalY: img.focal_y ?? null,
  }));
}

export function heroImagesToPublic(images: HeroImage[]): PublicGalleryImage[] {
  return images.map((img) => ({
    id: img.id && /^\d+$/.test(img.id) ? Number(img.id) : undefined,
    image_url: img.src,
    image_type: 'hero',
    title: img.title,
    alt_text: img.alt,
    focal_x: img.focalX ?? null,
    focal_y: img.focalY ?? null,
  }));
}
